import Breadcrumb from 'components/Breadcrumb'
import useDeviceDetect, { BrowserView } from 'components/DeviceDetect'
import Loader from 'components/Loader'
import SectionBlock from 'components/SectionBlock'
import Slider from 'components/Slider'
import {
  Details,
  FAQ as Faq,
  MainInfo,
  OftenBuy,
  Reviews,
  Specs,
} from 'components/Widgets/ProductInside'
import React, { useEffect } from 'react'
import { pageViewEvent } from 'services/conversionevents'
import useConfig from 'store/ConfigProvider'
import useProduct from 'store/SingleProductProvider'
import {
  AditionalInformation,
  ProductBreadcrumb,
  ProductContainer,
} from 'style/Product.style'
import { DesktopHeaderCategories } from '../../components/Widgets/Categories/Categories'
import ReportSection from '../../components/Widgets/ProductInside/ReportSection'
import { BrowserAndTabletView, MobileView } from 'components/DeviceDetect'

const ProductPage = props => {
  const { categories, topCategories } = useConfig()
  const { slug, path } = props.match.params
  const { isBrowser } = useDeviceDetect()
  const { product, setUrlParams, loading } = useProduct()
  useEffect(() => {
    setUrlParams(props.match.params)

    window.scrollTo(0, 0)
  }, [slug, path])

  useEffect(() => {
    if (!product.sku) return

    if (product.name) {
      document.title = product.name
    }

    pageViewEvent(product)
  }, [product.sku])

  if (loading && !product.sku) {
    return <Loader visible={true} type="ThreeDots" />
  }

  return (
    <ProductContainer
      itemScope
      itemType="https://schema.org/Product"
      key={product.sku}
    >
      {loading && product.sku ? (
        <Loader visible={true} transparent type="ThreeDots" />
      ) : null}
      <BrowserView>
        <DesktopHeaderCategories
          productPage
          categories={categories}
          topCategories={topCategories}
        />
      </BrowserView>
      <ProductBreadcrumb>
        <Breadcrumb
          data={[
            { name: 'მთავარი', to: '/', active: false },
            { name: 'კატეგორიები', to: '/all-category' },
            ...(Array.isArray(product.breadcrumb)
              ? product.breadcrumb.map(b => {
                  return { name: b.name, to: `/category/${b.slug}` }
                })
              : []),
          ]}
        />
      </ProductBreadcrumb>
      <meta
        itemProp="category"
        content={product.breadcrumb?.[product.breadcrumb.length - 1]?.name}
      />
      <meta itemProp="condition" content={product.cond} />
      <MainInfo product={product} />
      <OftenBuy products={product.frequent_boughts || {}} product={product} />
      <BrowserAndTabletView>
      <div className="my-10">
          <img src="/img/artboard.jpg" alt="artboard" />
        </div>
      </BrowserAndTabletView>
      <MobileView>
        <div className="my-10">
          <img src="/img/Artboard-mobile.jpg" alt="artboard" />
        </div>
      </MobileView>

      <div
        style={{
          paddingBottom: '10px',
          marginRight: '10px',
          marginLeft: '10px',
          borderBottom: '1px solid #ededed',
          width: '95%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <SectionBlock
          style={!isBrowser ? { width: '95%' } : { width: '100%' }}
          id="similar-products"
          title="მსგავსი პროდუქტები"
          withPaddingBottom
          titleComponent="h1"
        >
          <Slider
            type="product-items"
            settings={{ arrows: true, rows: 1 }}
            productItems={product.related_products || []}
          />
        </SectionBlock>
      </div>
      <AditionalInformation>
        <Details details={product.details || {}} />
        <Specs attributes={product.attributes || []} />
        <Reviews data={product.reviews || []} />
        <Faq data={product.faqs || []} />
        <ReportSection className="relative" />
      </AditionalInformation>
    </ProductContainer>
  )
}

export default ProductPage
